import { handleCopyProcess } from 'public/Design/handleCopyProcess';
import { changeTemplate } from 'public/Design/handleTemplateChange';

export async function initDesign() {
    const props = $widget.props;

    await changeTemplate(props.template);
    await handleCopyProcess(props.template);
}

export async function handlePropsChange(newProps) {
    await changeTemplate(newProps.template);
    await handleCopyProcess(newProps.template);
}